import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
	{
		name: 'IOI Inspections',
		url: '/products/ioi_inspections',
		icon: 'id-badge',
	}
];

export default class Ioi_Inspections extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalIOIInspection')} size="sm" color="primary">
						<i className="fa fa-id-badge"/>&nbsp;&nbsp;Start IOI Inspection
					</Button>
				</Framework.Components.PageBar>

				<Collections.IoiInspections
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name={"IOI Inspection"}
					object={Objects.IoiInspection}
					history={this.props.history}
					toggle={this.state['modalIOIInspection']}
					reportClose={this.reportClose('modalIOIInspection')}
					afterSave={this.handleAfterSave}
				/>

			</div>
		);
	}
}

